export function buildTripShareMessage(params: {
  startName: string;
  endName: string;
  distanceMeters: number;
  durationMin: number;
  imperial: boolean;
  alertSummary?: string;
}): string {
  const { startName, endName, distanceMeters, durationMin, imperial, alertSummary } = params;
  const dist = imperial
    ? (() => {
        const mi = distanceMeters / 1609.34;
        return mi >= 100 ? `${Math.round(mi)} mi` : `${mi.toFixed(1)} mi`;
      })()
    : (() => {
        const km = distanceMeters / 1000;
        return km >= 100 ? `${Math.round(km)} km` : `${km.toFixed(1)} km`;
      })();
  const dur =
    durationMin >= 60
      ? `${Math.floor(durationMin / 60)}h ${durationMin % 60}m`
      : `${Math.round(durationMin)} min`;
  let text = `${startName} -> ${endName}\n${dist} · ~${dur}`;
  if (alertSummary?.trim()) {
    text += `\nAlerts: ${alertSummary.trim()}`;
  }
  return text;
}
